"use client";

import { useState, useEffect } from "react";
import PlaceCard from "@/components/places/PlaceCard";
import PlaceFilters from "@/components/places/PlaceFilters";
import OtrasOpciones from "../components/OtrasOpciones";
import PlaceLayout from "@/components/places/PlaceLayout";
import { fetchConcesiones } from "@/lib/api/datosGenerales/fetchConcesiones";
import { Concesiones } from "@/lib/api/datosGenerales/types/concesiones";
import { useLocale } from "next-intl";
import { useTranslations } from "next-intl";
import ConcesionesLoadingSkeleton from "@/components/ConcesionesLoadingSkeleton";
import { type Locale } from "@/i18n/config";

const categories = ["Café", "Fast Food", "Healthy", "Sports Bar"];

export default function AlquilerPage() {
  const t = useTranslations("searchBar");
  const [selectedTerminal, setSelectedTerminal] = useState("todas");
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [search, setSearch] = useState("");
  const [data, setData] = useState<Concesiones[]>([]);
  const locale = useLocale() as Locale;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const concesiones = await fetchConcesiones(locale, "transp");
      setData(concesiones);
      setLoading(false);
    };
    fetchData();
  }, [locale]);
  if (loading) {
    return <ConcesionesLoadingSkeleton />;
  }
  const filteredData = data.filter((item) => {
    const matchesTerminal =
      selectedTerminal === "todas" || item.terminal.includes(selectedTerminal);
    const matchesCategory =
      selectedCategories.length === 0 ||
      selectedCategories.some((cat) => item.categoria.includes(cat));
    const matchesSearch = item.nombre
      .toLowerCase()
      .includes(search.toLowerCase());
    return matchesTerminal && matchesCategory && matchesSearch;
  });

  return (
    <>
      <PlaceLayout imageSrc="https://galeria.tocumenaero.com/gallery/api/%C3%81rea%20de%20Arrendadoras/321A8752.jpg">
        <PlaceFilters
          title={t("alquiler")}
          selectedTerminal={selectedTerminal}
          setSelectedTerminal={setSelectedTerminal}
          selectedCategories={selectedCategories}
          setSelectedCategories={setSelectedCategories}
          search={search}
          setSearch={setSearch}
          categories={categories}
          useFilter={false}
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-[80%] mx-auto my-10">
          {filteredData.length > 0 ? (
            filteredData.map((item) => (
              <PlaceCard
                key={item.id}
                id={item.id}
                image={item.foto}
                title={item.nombre}
                description={item.categoria || ""}
                terminales={[item.terminal || ""]}
                link={item.mapaUrl}
                tipo={item.tipoConcesion}
                detalleUbicacion={item.detalleUbicacion}
              />
            ))
          ) : (
            <p className="col-span-3 text-center pt-10 text-gray-500 font-medium">
              {t("error")}
            </p>
          )}
        </div>
        <div className="flex justify-center">
          <div className="w-[80%]">
            <OtrasOpciones actual="alquiler" />
          </div>
        </div>
      </PlaceLayout>
    </>
  );
}
